module.exports = __webpack_public_path__ + "static/media/al.0462e5b1.svg";